import styled, { keyframes } from "styled-components"
import { MEDIA_QUERIES } from "@constants"
import LpSection from "@components/lp/LpSection/LpSection"

const MaskImageFade = keyframes`
  0% {
    mask-position: top;
  }

  100% {
    mask-position: bottom;
  }
`

export const PricingBlockSECTION = styled(LpSection)`
  --Plans--gap: 12px;

  .container > .grid {
    gap: var(--spacing--M);
  }

  .section-content {
    text-align: center;

    ${MEDIA_QUERIES.L} {
      text-align: left;
    }
  }
  
  h2 {
    text-wrap: balance;
  }

  p {
    max-width: var(--text-max-width);
  }

  .pricing-cards-wrapper {
    display: flex;
    align-items: center;

    ${MEDIA_QUERIES.L} {
      justify-content: flex-end;
    }
  }

  .pricing-cards {
    display: flex;
    justify-content: center;
    gap: var(--Plans--gap);
    width: 100%;

    ${MEDIA_QUERIES.M} {
      &:hover {
        .plan:not(:hover) {
          opacity: 0.6;
          animation: ${MaskImageFade} 0.3s forwards;
        }
      }
    }
  }
`

export const PricingPlanCardDIV = styled.div`
  // Free plan color
  --Plan--gradient-color: var(--color--clay-100-rgb);
  --Plan--radial-gradient-color: var(--color--clay-400-rgb);
  --Plan--border-padding: 6px;
  --Plan--gradient-border-radius: calc(var(--border-radius--L) * 0.4);

  background: var(--color--basics-white);
  border-radius: var(--border-radius--L);
  border: 1px solid rgba(var(--color--cobalt-900-rgb), 0.08);
  box-shadow: var(--elevation--S);
  display: none;
  flex-direction: column;
  flex: 0 0 max(200px, calc(33.3333% - var(--Plans--gap) * 2 / 3));
  gap: var(--spacing--L);
  padding: 24px;
  position: relative;
  transition: all 0.3s ease-in-out;

  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0,0,0,1) 50%, rgba(0, 0, 0, 0) 100%);
  mask-size: 100% 200%;

  &:nth-of-type(3) {
    display: flex;
  }

  &.plan--standard {
    --Plan--gradient-color: var(--color--green-100-rgb);
    --Plan--radial-gradient-color: var(--color--green-400-rgb);
  }

  &.plan--plus {
    --Plan--gradient-color: var(--color--cobalt-100-rgb);
    --Plan--radial-gradient-color: var(--color--cobalt-400-rgb);
  }

  &.plan--pro {
    --Plan--gradient-color: var(--color--purple-100-rgb);
    --Plan--radial-gradient-color: var(--color--purple-400-rgb);
  }

  ${MEDIA_QUERIES.M} {
    display: flex;

    &:hover {
      transform: scale(1.0333);
      translate: 0 -4%;
      z-index: 1;
    }
  }

  ${MEDIA_QUERIES.XL} {
    padding: 30px;
  }

  &:hover {
    box-shadow: var(--elevation--M);
  }

  &::before {
    content: "";
    display: block;
    background: linear-gradient(to right, rgb(var(--Plan--gradient-color)), rgb(var(--Plan--radial-gradient-color)));
    border-radius: var(--Plan--gradient-border-radius) var(--Plan--gradient-border-radius) 0 0;
    height: var(--Plan--border-padding);
    left: var(--Plan--border-padding);
    position: absolute;
    top: var(--Plan--border-padding);
    width: calc(100% - var(--Plan--border-padding) * 2);
  }

  .gradient-background {
    border-radius: var(--Plan--gradient-border-radius);
    height: 90%;
    left: var(--Plan--border-padding);
    opacity: 0.5;
    overflow: hidden;
    position: absolute;
    top: var(--Plan--border-padding);
    width: calc(100% - var(--Plan--border-padding) * 2);
    z-index: 0;

    &::before,
    &::after {
      content: "";
      display: block;
      background:
        url("/images/noise-overlay.png"),
        radial-gradient(circle at 100% 0%, rgba(var(--Plan--radial-gradient-color), 0.45) 0%, rgba(var(--Plan--radial-gradient-color), 0) 33.3333%),
        rgba(var(--Plan--gradient-color), 1);
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    &::before {
      border: 0.5px solid rgba(var(--color--cobalt-900-rgb), 0.05);
      z-index: 1;
    }

    &::after {
      background: linear-gradient(180deg, rgba(var(--color--basics-white-rgb), 0), rgba(var(--color--basics-white-rgb), 1));
      z-index: 2;
    }
  }

  .plan-details {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .plan-price {
    display: flex;
    align-items: center;
    gap: 4px;

    span {
      margin: 0;
    }

    .plan-price--mo {
      opacity: var(--opacity--60);
    }
  }

  .Button {
    position: relative;
    z-index: 1;
    width: 100%;
  }
`
